import alert from '@/plugins/alert'
import { Student, Class, Teacher, Post, Attendance, Violation, Message, MessageGroup } from '@/plugins/api'
import { keyBy } from 'lodash'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    classNo: 0,
    studentNo: 0,
    teacherNo: 0,
    posts: [],
    recentFeedbacks: [],
    todayAttendanceCount: 0,
    todayAbsentCount: 0,
    commendationWeekCount: 0,
    violationWeekCount: 0
  },
  actions: {
    async fetchDashboardData({ commit }, options) {
      try {
        // Lấy số lượng lớp học, học sinh, giáo viên
        const [classNo, studentNo, teacherNo] = await Promise.all([
          Class.count({ ...options, status: 'running' }),
          Student.count({ ...options, status: 'active' }),
          Teacher.count({ status: 'active' })
        ])
        commit('changeState', { classNo, studentNo, teacherNo })

        // Điểm danh
        const now = moment()
        const dayGte = now.startOf('day').toISOString()
        const dayLte = now.endOf('day').toISOString()

        const attendanceParams = {
          time_gte: dayGte,
          time_lte: dayLte,
          status_in: ['attendance', 'left']
        }

        const todayAttendanceCount = await Attendance.count(attendanceParams)
        const todayAbsentCount = studentNo - todayAttendanceCount

        commit('changeState', {
          todayAttendanceCount,
          todayAbsentCount
        })

        // Khen thưởng - kỷ luật
        const weekGte = now.startOf('week').toISOString()
        const weekLte = now.endOf('week').toISOString()
        const violaltionParams = {
          date_gte: weekGte,
          date_lte: weekLte
        }

        const commendationWeekCount = await Violation.count({ ...violaltionParams, type: 'commendation' })
        const violationWeekCount = await Violation.count({ ...violaltionParams, type: 'violation' })
        commit('changeState', {
          commendationWeekCount,
          violationWeekCount
        })
      } catch (e) {
        alert.error(e)
      }
    },
    async fetchNotifications({ commit }, options) {
      const posts = await Post.fetch({
        student_null: true,
        type_ne: 'attendance',
        _limit: 10,
        _sort: 'createdAt:DESC'
      })
      commit('changeState', { posts })
    },
    async fetchFeedback({ commit }, options) {
      const messageGroups = await MessageGroup.fetch({
        ...options,
        _limit: 5,
        _sort: 'lastMessageTime:desc'
      })

      const groups = keyBy(messageGroups, 'id')
      await Promise.all(
        messageGroups.map(async group => {
          const lastParentMessages = await Message.fetch({
            messageGroup: group.id,
            senderType: 'student',
            _limit: 1,
            _sort: 'time:DESC'
          })
          if (lastParentMessages && lastParentMessages[0]) {
            groups[group.id].lastParentMessage = lastParentMessages[0]
            groups[group.id].isReply = lastParentMessages[0].id !== (group.lastMessage && group.lastMessage.id)
          }
        })
      )

      const recentFeedbacks = Object.values(groups)

      commit('changeState', { recentFeedbacks })
    }
  },
  mutations: {},
  getters: {
    posts: state => {
      const postFiltered = state.posts.filter(p => !p.student)
      return postFiltered.map(p => {
        if (p.school) p.postToType = 'Toàn trường'
        else if (p.grade) p.postToType = p.grade.title
        else if (p.class) p.postToType = `Lớp ${p.class.title}`
        // else if (p.student) p.postToType = `Học sinh ${p.student.name}`
        return p
      })
    }
  }
}
